export const SET_SUBSCRIPTION = '[CHOOSE PLAN] SET_SUBSCRIPTION';
export const SET_SUBSCRIPTION_LIST = '[CHOOSE PLAN] SET_SUBSCRIPTION_LIST';
export const SET_COUPON_INFO = '[CHOOSE PLAN] SET_COUPON_INFO';
export const SET_COUPON_LOADING = '[CHOOSE PLAN] SET_COUPON_LOADING';
export const SET_LOADING = '[CHOOSE PLAN] SET_LOADING';
export const CLEAR_DATA = '[CHOOSE PLAN] CLEAR_DATA';
